import createURLParams from '@/api/datasource/createURLParams'
import { http } from '@/api/httpAxios'
import { ChangeRequest } from '@/components/routes/changes-requests/helpers/types'
import { LessonChangeAllow } from '@/components/routes/changes-requests/helpers/config'

function getRequests(
  limit: number,
  offset: number,
  sort: { [k: string]: any } | null,
  filter: { [k: string]: any } | null
) {
  const params = createURLParams(limit, offset, sort, filter)

  return http.get<{ count: { count: number }[]; rows: ChangeRequest[] }>(
    '/schedule/changes/lesson-instance/requests',
    { params }
  )
}

function decideDep(id: number[], accept: LessonChangeAllow) {
  return http.post('/schedule/changes/lesson-instance/request/accept/dep', {
    id,
    accept
  })
}

function decideSED(
  id: number[],
  accept: LessonChangeAllow,
  rejectReason?: string
) {
  return http.post('/schedule/changes/lesson-instance/request/accept/sed', {
    id,
    accept,
    ...(rejectReason && { rejectReason })
  })
}

function getAvailableRequests() {
  return http.get<number>('/schedule/changes/lesson-instance/requests/count')
}

function restoreChanges(id: number[]) {
  return http.post('/schedule/changes/lesson-instance/request/restore', { id })
}

function declineRequests(id: number[]) {
  return http.delete('/schedule/changes/lesson-instance/request/decline', {
    data: { id }
  })
}

export const ChangesRequestsApi = {
  getRequests,
  decideDep,
  decideSED,
  getAvailableRequests,
  restoreChanges,
  declineRequests
}
